if (!customElements.get('sticky-buy')) {
  customElements.define(
    'sticky-buy',
    class StickyBuy extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.button = this.querySelector('[data-sticky-submit]');
        this.label = this.querySelector('[data-sticky-label]');
        this.priceEl = this.querySelector('[data-sticky-price]');
        if (!this.button || !this.sectionId) return;

        // フォームは複製しない。本物の送信ボタンを押しに行くだけにする
        this.button.addEventListener('click', () => {
          const real = this.realSubmit;
          if (!real || real.hasAttribute('disabled')) return;
          real.click();
        });

        this.watchRealButton();
        this.watchState();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.stateObserver?.disconnect();
      }

      get realSubmit() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      // 本来のカートボタンが画面外に出たときだけバーを出す。
      // 画面内にあるなら同じボタンが2つ見えることになるので出さない。
      watchRealButton() {
        const real = this.realSubmit;
        if (!real || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.hidden = entry.isIntersecting;
            });
          },
          { rootMargin: '0px 0px -10% 0px' }
        );
        this.observer.observe(real);
      }

      // 売り切れ・購入不可の状態と価格を本物側から写す。
      // バリアント切替のたびに Dawn が本物のボタンと価格を差し替えるので、それを監視する。
      watchState() {
        const real = this.realSubmit;
        const price = document.getElementById(`price-${this.sectionId}`);
        if (!real) return;

        const sync = () => {
          const disabled = real.hasAttribute('disabled');
          this.button.toggleAttribute('disabled', disabled);
          const realLabel = real.querySelector('span');
          if (this.label && realLabel) this.label.textContent = realLabel.textContent.trim();
          if (this.priceEl && price) {
            const amount = price.querySelector('.price-item--sale, .price-item--regular');
            if (amount) this.priceEl.textContent = amount.textContent.trim();
          }
        };

        sync();
        this.stateObserver = new MutationObserver(sync);
        this.stateObserver.observe(real, { attributes: true, childList: true, subtree: true });
        if (price) this.stateObserver.observe(price, { childList: true, subtree: true });
      }
    }
  );
}
